import * as types from '../ActionTypes/UserActionTypes';

export class UserActionCreators {
    // sign in with facebook
    static signInUserWithFacebookSuccess = social_token => ({
        type: types.SIGN_IN_USER_WITH_FACEBOOK_SUCCESS,
        payload: { social_token },
    });

    static signInUserWithFacebookFailed = payload => ({
        type: types.SIGN_IN_USER_WITH_FACEBOOK_FAILED,
        payload,
    });

    // register gym
    static registerGymUserRequest = (payload, completion) => ({
        type: types.REGISTER_GYM_USER_REQUEST,
        payload: { payload, completion },
    });

    static registerGymUserSuccess = payload => ({
        type: types.REGISTER_GYM_USER_SUCCESS,
        payload,
    });

    static registerGymUserFailed = payload => ({
        type: types.REGISTER_GYM_USER_FAILED,
        payload,
    });

    // register standard user
    static registerStandardUserRequest = (payload, completion) => ({
        type: types.REGISTER_STANDARD_USER_REQUEST,
        payload: { payload, completion },
    });

    static registerStandardUserSuccess = payload => ({
        type: types.REGISTER_STANDARD_USER_SUCCESS,
        payload,
    });

    static registerStandardUserFailed = payload => ({
        type: types.REGISTER_STANDARD_USER_FAILED,
        payload,
    });

    // forgot password
    static forgotPasswordRequest = payload => ({
        type: types.FORGOT_PASSWORD_REQUEST,
        payload,
    });

    static forgotPasswordSuccess = payload => ({
        type: types.FORGOT_PASSWORD_SUCCESS,
        payload,
    });

    static forgotPasswordFailed = payload => ({
        type: types.FORGOT_PASSWORD_FAILED,
        payload,
    });

    // get authenticated user
    static getAuthenticatedUserRequest = () => ({
        type: types.GET_AUTHENTICATED_USER_REQUEST,
    });

    static getAuthenticatedUserSuccess = payload => ({
        type: types.GET_AUTHENTICATED_USER_SUCCESS,
        payload,
    });

    static getAuthenticatedUserFailed = payload => ({
        type: types.GET_AUTHENTICATED_USER_FAILED,
        payload,
    });

    // get authenticated user preferences
    static getAuthenticatedUserPreferencesRequest = userId => ({
        type: types.GET_AUTHENTICATED_USER_PREFERENCES_REQUEST,
        meta: { userId },
    });

    static getAuthenticatedUserPreferencesSuccess = payload => ({
        type: types.GET_AUTHENTICATED_USER_PREFERENCES_SUCCESS,
        payload,
    });

    static getAuthenticatedUserPreferencesFailed = payload => ({
        type: types.GET_AUTHENTICATED_USER_PREFERENCES_FAILED,
        payload,
    });

    // sign in
    static signInUserRequest = (credentials, completionCallback) => ({
        type: types.SIGN_IN_USER_REQUEST,
        payload: { ...credentials, completionCallback },
    });

    static signInUserSuccess = payload => ({
        type: types.SIGN_IN_USER_SUCCESS,
        payload,
    });

    static signInUserFailed = payload => ({
        type: types.SIGN_IN_USER_FAILED,
        payload,
    });

    // sign out
    static signOutRequest = (deviceId, completionCallback) => ({
        type: types.SIGN_OUT_USER_REQUEST,
        payload: { deviceId, completionCallback },
    });

    static signOutSuccess = () => ({
        type: types.SIGN_OUT_USER_SUCCESS,
    });

    static signOutFailed = payload => ({
        type: types.SIGN_OUT_USER_FAILED,
        payload,
    });

    // clear errors
    static clearAuthenticationErrors = () => ({
        type: types.CLEAR_AUTHENTICATION_ERRORS,
    });

    // delete account
    static deleteUserAccountRequest = () => ({
        type: types.DELETE_USER_ACCOUNT_REQUEST,
    });

    static deleteUserAccountSuccess = () => ({
        type: types.DELETE_USER_ACCOUNT_SUCCESS,
    });

    static deleteUserAccountFailed = payload => ({
        type: types.DELETE_USER_ACCOUNT_FAILED,
        payload,
    });
}



// WEBPACK FOOTER //
// ./src/Store/ActionCreators/UserActionCreators.js